import React from 'react';
import { Typography } from '../Typography/Typography';
import styles from './BreadcrumbHeading.module.scss';
import { IOption } from '../Dropdown/Dropdown';
import { ArrowForward } from '../../assets/icons/ArrowForward';
import { Link } from 'react-router-dom';
import DropdownButton from '../DropdownButton/DropdownButton';
import Button from '../Button/Button';

export interface IBreadcrumbHeadingProps {
  onButtonClick?: () => void;
  optionMenuItems?: IOption[];
  buttonTitle?: string;
  breadcrumbs: { label: string; path: string }[];
  subtitle?: string;
  buttonDisabled?: boolean;
}

export const BreadcrumbHeading = ({
  onButtonClick: onButtonClick = undefined,
  breadcrumbs = [],
  optionMenuItems = [],
  buttonTitle,
  subtitle,
  buttonDisabled = false,
}: IBreadcrumbHeadingProps) => {
  return (
    <div>
      <div className={styles['page-heading']}>
        <div className={styles['left-content']}>
          {breadcrumbs.map((item, index) =>
            index < breadcrumbs.length - 1 ? (
              <Link key={`${item.path}${index}`} to={item.path} className={styles['breadcrumb-link']}>
                <div className={styles['title-container']}>
                  <Typography size="XXL" weight="regular" className={styles['text']}>
                    {item.label}
                  </Typography>
                  <ArrowForward />
                </div>
              </Link>
            ) : (
              <div key={`${item.path}${index}`} className={styles['button-container']}>
                {optionMenuItems.length > 0 ? (
                  <DropdownButton
                    variant={optionMenuItems.length > 1 ? 'ellipsis' : 'arrow'}
                    text={item.label}
                    primary={false}
                    options={optionMenuItems}
                  />
                ) : (
                  <Typography size="XXL" weight="semi-bold" className={styles['text']}>
                    {item.label}
                  </Typography>
                )}
              </div>
            ),
          )}
        </div>
        <div className={styles['right-content']}>
          {buttonTitle && (
            <Button onClick={onButtonClick} primary disabled={buttonDisabled}>
              {buttonTitle}
            </Button>
          )}
        </div>
      </div>
      {subtitle && (
        <Typography size="S" weight="regular">
          {subtitle}
        </Typography>
      )}
    </div>
  );
};
